import { FONT_FAMILY } from "../../theme";

export const styles = {
  popupContainer: {
    position: "fixed",
    bottom: "5px",
    left: "10px",
    backgroundColor: "black",
    color: "white",
    boxShadow: "24px",
    padding: "16px",
    margin: "0 10px 10px 0",
    zIndex: 30000,
    borderRadius: "5px",
  } as const,
  closeIcon: {
    color: "grey",
    "&:hover": {
      cursor: "pointer",
      "&:hover": { color: "grey" },
    },
  } as const,
  upgradeButton: {
    fontFamily: FONT_FAMILY,
    margin: "0 5px 0 15px",
    color: "#3bb9c8",
    fontSize: "20px",
    "&:hover": { textDecoration: "bold" },
  },
};
